import { uploadDocAPI } from 'services/workspaceAPI/';
import { OrderTypeKeys, IDocumentUpload } from '../../types';
import {
  createFormData,
  generateInternalDocumentName,
} from 'utils/orderDocuments';

export const executeCustomerDocumentUpload = (
  upload: IDocumentUpload,
  fileName: string
) => {
  return async (dispatch) => {
    const { customerDocumentId, file, metadata, fileID } = upload;

    const formData = createFormData({
      File: file,
      ...(customerDocumentId && { CustomerDocumentId: customerDocumentId }),
      ...(metadata.displayName && { DisplayName: metadata.displayName }),
      ...(metadata.notes && { Notes: metadata.notes }),
      ...(metadata.secured && { Secured: JSON.stringify(metadata.secured) }),
    });

    return uploadDocAPI({ 'Content-Type': 'multipart/form-data' }).post(
      `/orders/${fileID}/customerdocuments/upload`,
      formData,
      {
        onUploadProgress: (e) => {
          dispatch({
            type: OrderTypeKeys.UI_UPDATE_DOC_UPLOAD_PROGRESS,
            progress: Math.round((e.loaded * 100) / e.total),
            fileName: fileName,
          });
        },
      }
    );
  };
};

export const executeDocumentUpload = (
  upload: IDocumentUpload,
  fileName: string
) => {
  return async (dispatch) => {
    const { file, metadata, fileID } = upload;

    const formData = createFormData({
      File: file,
      Type: metadata.type.split('#')[0],
      SubType: generateInternalDocumentName(upload),
      ...(metadata.displayName && { DisplayName: metadata.displayName }),
      ...(metadata.notes && { Notes: metadata.notes }),
      ...(metadata.sdnHitId && { sdnHitId: metadata.sdnHitId.toString() }),
    });

    return uploadDocAPI({ 'Content-Type': 'multipart/form-data' })
      .post(`/orders/${fileID}/documents`, formData, {
        onUploadProgress: (e) => {
          dispatch({
            type: OrderTypeKeys.UI_UPDATE_DOC_UPLOAD_PROGRESS,
            progress: Math.round((e.loaded * 100) / e.total),
            fileName: fileName,
          });
        },
      })
      .then((data) => {
        return { ...upload, documentId: data.data };
      })
      .catch((error) => {
        dispatch({
          error,
          type: OrderTypeKeys.UI_COMPLETE_ACTIVE_DOCUMENT_UPLOAD,
          fileName: fileName,
        });
      });
  };
};

export const executeDepositUpload = (
  upload: IDocumentUpload,
  fileName: string
) => {
  return async (dispatch) => {
    const { file, metadata, fileID } = upload;

    const formData = createFormData({
      File: file,
      Type: metadata.type.split('#')[0],
      SubType: generateInternalDocumentName(upload),
      ...(metadata.displayName && { DisplayName: metadata.displayName }),
      ...(metadata.notes && { Notes: metadata.notes }),
    });

    return uploadDocAPI({ 'Content-Type': 'multipart/form-data' }).post(
      `/orders/${fileID}/deposits/${metadata.depositId}/upload`,
      formData,
      {
        onUploadProgress: (e) => {
          dispatch({
            type: OrderTypeKeys.UI_UPDATE_DOC_UPLOAD_PROGRESS,
            progress: Math.round((e.loaded * 100) / e.total),
            fileName: fileName,
          });
        },
      }
    );
  };
};
